export const state = {
  total: 50,
  page: 0,
  dateRange: ["2010-05-21", "2020-12-21"],
  data: [],
  loading: false,
  error: null,
};
